import { Button, Card, Col, Form, Input, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addRejectReason, deleteRejectReason, getAllRejectReason, updateRejectReason } from '../../redux/rtk/features/masters/rejectReasonSlice';
import PageTitle from '../page-header/PageHeader';

const RejectReasonMaster = () => {
  const { Title } = Typography;
  const [editingRejectReason, setEditingRejectReason] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.rejectReason);

  useEffect(() => {
    dispatch(getAllRejectReason());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingRejectReason) {
        // Update existing rejectReason
        const result = await dispatch(
          updateRejectReason({ id: editingRejectReason.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRejectReason());
        } else {
          // message.error('Error updating rejectReason!');
        }
      } else {
        // Add new rejectReason
        const result = await dispatch(addRejectReason(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRejectReason());
        } else {
          // message.error('Error adding rejectReason!');
        }
      }
      setEditingRejectReason(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update reject reason!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteRejectReason(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllRejectReason()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Reject Reason',
      dataIndex: 'rejectReason',
      key: 'rejectReason',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingRejectReason(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this reject reason?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingRejectReason ? 'Edit Reject Reason' : 'Add Reject Reason'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="reject-reason-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="rejectReason"
            label="Reject Reason"
            rules={[{ required: true, message: 'Please enter a reject reason !' }]}
          >
            <Input placeholder="Enter reject reason" />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingRejectReason ? 'Update Reject Reason' : 'Add Reject Reason'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Reject Reason List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RejectReasonMaster;
